import React from "react";

import { IMatchDatesStatusContext } from "./types";

export const MatchDatesStatusContext = React.createContext({} as IMatchDatesStatusContext);

export function useMatchDatesStatusContext() {
  const context = React.useContext(MatchDatesStatusContext);

  if (!context) {
    throw new Error("useMatchDatesStatusContext must be inside MatchDatesStatusProvider");
  }

  return context;
}
